module.exports = __webpack_public_path__ + "static/media/rate-2.30f3bd72.svg";